"use client";

import { useEffect, useRef } from "react";
import { useClaritySession } from "@/lib/auth/auth-store";
import { identifyUser, setSuperProperties, resetAnalytics } from "./mixpanel";

function registerEnvironmentProperties(): void {
  setSuperProperties({
    env: process.env.NEXT_PUBLIC_ENVIRONMENT ?? process.env.NODE_ENV,
    app_version: process.env.NEXT_PUBLIC_RELEASE_VERSION,
  });
}

export function useInitializeAnalytics(): void {
  const session = useClaritySession();
  const identifiedUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (session.status === "authenticated") {
      const userId =
        typeof session.claims.sub === "string" ? session.claims.sub : "";

      if (userId && identifiedUserIdRef.current !== userId) {
        identifiedUserIdRef.current = userId;

        const userProps: Record<string, unknown> = {};

        if (typeof session.claims.email === "string") {
          userProps.$email = session.claims.email;
        }
        if (typeof session.claims.name === "string") {
          userProps.$name = session.claims.name;
        }

        identifyUser(userId, userProps);
      }
    } else if (session.status === "signed_out") {
      identifiedUserIdRef.current = null;
      resetAnalytics();
    }

    registerEnvironmentProperties();
  }, [session]);
}
